import React from 'react';
import './index.scss';


//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';



//other libraries
import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';


@inject('translate')
@inject('internal')
@observer
export default class ChooseCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedObjects: [],
            values: [this.props.categories],
            valuesTags: [this.props.tags],
            selectedTags: [],
            checkedRows: toJS(this.props.internal.checkedRows),
            selectedNames: []
        }
    }

    componentDidMount() {
        if(this.props.idCategory) {
            this.makeRoute()
        }
    }

    handleChange = (event) => {
        if(event.target.value !== "") {
            let values = this.state.values;
            values.splice(event.target.value.level+1);
            let selectedObj = this.state.selectedObjects
            selectedObj.splice(event.target.value.level);
            selectedObj.push(event.target.value)
            this.setState({selectedObjects: selectedObj})

            let selectedNames = this.state.selectedNames
            selectedNames.push(event.target.value.name)
            this.setState({selectedNames: selectedNames})

            if(event.target.value.children.length) {
                values.push(event.target.value.children)
                this.setState({values: values})
            }
        }
        else {
            let values = this.state.values;
            let selectedObj = this.state.selectedObjects
            if(values.length === selectedObj.length) {
                selectedObj.splice(selectedObj.length-1)
                this.setState({selectedObjects: selectedObj})
            }
        }
    }

    editCategory = {}
    makeRoute = () => {
        
        let parents = toJS(this.props.internal.parents)
        parents[0] = {name: "TOP level", parent_id: null, id:0, children: []}
        
        let categories = this.props.categoriesList
        for(let i=0; i < categories.length; i++) {
            if(this.props.idCategory) {
                if(categories[i].id === this.props.idCategory) {
                    this.editCategory = categories[i]
                }
            }
        }

        let parentsOfCategory = []

        let tmpValues = this.state.values
        if(this.editCategory.parent_id !== null && Object.keys(this.editCategory).length > 0) {
            let parent = categories.filter(i => i.id === this.editCategory.parent_id )[0]
            parentsOfCategory.push(parent)
            
            while (parent.parent_id !== null) {
                parent = categories.filter(i => i.id === parent.parent_id)[0]
                parentsOfCategory.push(parent)
                
            }

            parentsOfCategory.reverse();

            // let tmpValues = this.state.values
            for(let i=0; i<parentsOfCategory.length; i++) {
                if(parentsOfCategory[i].children) {
                    tmpValues.push(parentsOfCategory[i].children)
                }
            }
        }
        parentsOfCategory.push(this.editCategory)
        this.setState({selectedObjects: parentsOfCategory, values: tmpValues})
    }

    action = (data) => {

        this.props.setCategory(this.state.selectedObjects[this.state.selectedObjects.length - 1].id)
        
            // let update_data = await api({
            //     method: 'patch',
            //     url: 'products/pair-category',
            //     authorization: this.props.internal.user.access_token,
            //     params: {
            //         category: this.state.selectedObjects[this.state.selectedObjects.length - 1].id,
            //         products: this.state.checkedRows
            //     }
            // })
            // if(update_data.success === true) {
            //     // this.props.showSnackbar(update_data.data.message, true, true)
            //     this.props.internal.setSnackbar(update_data.data.message, true)
            //     this.props.closeDialog(true)
            // }
        


        
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                
            >
                <DialogTitle id="form-dialog-title">{this.props.translate.i18n.MODULES.PRODUCTS.EDIT_CATEGORY}</DialogTitle>
                <DialogContent className={'categorise-dialog'}>
                    
                    {
                        this.state.values.map((options, index) => {return (
                            <React.Fragment key={index}>
                            <FormControl className='tags-selector'>
                                {index === 0 ? <InputLabel htmlFor={`category-${index}`} className={'label-select-tag'}>{this.props.translate.i18n.MODULES.PRODUCTS.CHOOSE_CATEGORY}</InputLabel> : null }
                                <Select
                                    className={'select-category'}
                                    value={this.state.selectedObjects[index] ? this.state.selectedObjects[index].name: ""}
                                    onChange={this.handleChange}
                                    renderValue={() => {return(<span>{this.state.selectedObjects[index].name}</span>)}}
                                    
                                    >
                                    {
                                        index > 0 ? <MenuItem key="0" value="">{this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY_NONE}</MenuItem> : null
                                    }
                                    {
                                        options.map((option, optionIndex) => {
                                            return (
                                                <MenuItem key={optionIndex} value={option}>{option.name}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                </FormControl>
                            </React.Fragment>
                        )})
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <Button onClick={this.action} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button>
                </DialogActions>
                
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/basic/addCategory/index.js